import {createApp } from 'vue'
import store from './store/store'
import favoritesStore from './store/favoritesStore'
import BlogListApp from './BlogListApp.vue'
import PersonListApp from './PersonListApp.vue'
import TripfinderApp from './TripfinderApp.vue'
import AddToFavoritesApp from './AddToFavoritesApp.vue'
import ProfileFavoritesApp from './ProfileFavoritesApp.vue'
import PublicWishlistApp from './PublicWishlistApp.vue'
import { dragscrollNext } from "vue-dragscroll"
import '../js/main'
import '../scss/main.scss'

if (document.getElementById("blogListApp") !== null) {
    createApp(BlogListApp).use(store).mount('#blogListApp')
}

if (document.getElementById("personListApp") !== null) {
    createApp(PersonListApp).use(store).mount('#personListApp')
}

if (document.getElementById("tripFinderApp") !== null) {
    createApp(TripfinderApp).use(store).mount('#tripFinderApp')
}

if (document.getElementById("addToFavoritesApp") !== null) {
    createApp(AddToFavoritesApp).use(favoritesStore).directive('dragscroll', dragscrollNext).mount('#addToFavoritesApp')
}

if (document.getElementById("profileFavoritesApp") !== null) {
    createApp(ProfileFavoritesApp).use(favoritesStore).mount('#profileFavoritesApp')
}

if (document.getElementById("publicWishlistApp") !== null) {
    createApp(PublicWishlistApp).use(favoritesStore).mount('#publicWishlistApp')
}